module.exports = __webpack_public_path__ + "static/media/logo.9f8c6ae6.jpg";